module.exports = __webpack_public_path__ + "static/media/Tile2.5d6d4e5d.png";